import { Component, ComponentRef, ElementRef, EventEmitter, Injector, Input, Output, viewChild, ViewChild } from '@angular/core';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../service/auth-service/auth-service.service';
import { Art57Section } from '../../../ui/Art57Section/Art57Section';
import { Art57Node } from '../../../ui/Node/Art57Node/Art57Node';
import { Art57NodeList } from '../../../ui/Node/Art57Node/Art57NodeList';
import { Art57NodeUtils } from '../../../ui/Node/Art57Node/Art57NodeUtils';
import { TreeNodeImportedMessagesList } from '../../../ui/Node/Art57Node/ListEntity/TreeNodeImportedMessagesList';
import { QueryNode } from '../../../ui/Node/QueryNode';
import { TreeNodeXEVPRMImportedMessage } from '../../../ui/Node/WebTraderNode/Entity/TreeNodeXEVPRMImportedMessage';
import { SectionName } from '../../../ui/SectionName';
import { QueryNodeInBox } from '../../../ui/Node/WebTraderNode/Query/QueryNodeInBox';
import { QueryResultNode } from '../../../ui/Node/QueryResultNode';
import { ResultList } from '../../../ui/Node/ListEntity/ResultList';
import { QueryConditionsNode } from '../../../ui/Node/QueryConditionsNode';
import { QueryNodeMessageBox } from '../../../ui/Node/WebTraderNode/QueryNodeMessageBox';
import { QueryNodeOutBox } from '../../../ui/Node/WebTraderNode/Query/QueryNodeOutBox';
import { LookupGetService } from '../../../service/lookup-service/lookup-get.service';
import { BulkUpdateList } from '../../../ui/Node/WebTraderNode/ListEntity/BulkUpdateList';
import { LocalFileSelectorComponent } from '../../local-file-selector/local-file-selector.component';
import { IMPORT_TYPE, WebtraderService } from '../../../service/webtrader-service/webtrader.service';
import { ResultListNodeOutbox } from '../../../ui/Node/WebTraderNode/ListEntity/ResultListNodeOutbox';
import { ResultListNodeInbox } from '../../../ui/Node/WebTraderNode/ListEntity/ResultListNodeInbox';
import { BaseNode } from '../../../ui/Node/BaseNode';
import { SectionService } from '../../../service/section-service/section-service';
import { QueryNodeToEudravigilance } from '../../../ui/Node/WebTraderNode/Query/QueryNodeToEudravigilance';
import { ResultListNodeToEudravigilance } from '../../../ui/Node/WebTraderNode/ListEntity/ResultListNodeToEudravigilance';
import { QueryNodeFromEudravigilance } from '../../../ui/Node/WebTraderNode/Query/QueryNodeFromEudravigilance';
import { ResultListNodeFromEudravigilance } from '../../../ui/Node/WebTraderNode/ListEntity/ResultListNodeFromEudravigilance';


@Component({
  selector: 'app-webtrader-toolbox',
  templateUrl: './webtrader-toolbox.component.html',
  styleUrl: './webtrader-toolbox.component.scss'
})

export class WebtraderToolboxComponent {
  @Input() selectedNode: any;
  @Output() buttonAction = new EventEmitter();
  @Output() itemFinderDoubleClick = new EventEmitter();
  @ViewChild(LocalFileSelectorComponent) localFileSelector!: LocalFileSelectorComponent;


  displayDialog: boolean = false;
  fileContent: string = '';
  selectedFile: File | null = null;
  sortOrder: boolean = true;

  constructor(public authService: AuthService,
    private injector: Injector
  ) { }

  onFileContentChange(content: string) {
    this.fileContent = content;
  }

  doReloadImportTask(selectedNode: Art57Node): Promise<boolean> {

    if (!this.injector.get(SectionService).isAllowedProductReports()) {
      return Promise.resolve(false);
    }

    return new Promise((resolve, reject) => {
      try {
        this.injector.get(Art57Section).productReports.resetSection();
        this.injector.get(Art57Section).setSelectedSection(SectionName.createandsendproductreports); // to allow re-enable fields from webtrader nodes in productresports
        selectedNode.children!.forEach(child => {
          const childType = child.constructor as new (...args: any[]) => Art57Node;
          const parentForClonedNode = (Art57NodeUtils.findFirstChildNodeOfType(this.injector.get(Art57Section).productReports.treeView[0], childType) as Art57Node);
          child.children!.forEach(nodeToImport => {
            let node = (nodeToImport as Art57Node).cloneNode(parentForClonedNode);
            if (node != undefined) {
              parentForClonedNode.children?.push(node);
            }
          });
          parentForClonedNode.refreshLabel();
        });
        this.injector.get(Art57Section).productReports.selectedNode = this.injector.get(Art57Section).productReports.treeView[0];
        resolve(true);
      } catch (error) {
        reject(error);
      }
    });


  }

  doReloadImport(selectedNode: Art57Node) {
    this.injector.get(Art57Section).confirmationService.confirm({
      header: 'Information',
      message: 'This action will replace any content in Create and Send Products Section with the selected message\n' +
        'Do you wish to continue?',
      icon: 'pi pi-question-circle',
      acceptLabel: 'OK',
      rejectLabel: 'Cancel',
      accept: () => {

        this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Loading imported message...', life: environment.successElapsedTime });

        setTimeout(() => {

          this.doReloadImportTask(selectedNode)
            .then(result => {
              if (result == true) {
                this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Imported message successfully loaded', life: environment.successElapsedTime });
              }
            });

        }, 100);

      },
      reject: () => {
      }
    });

  }

  async onButtonAction(buttonAction: String, parameter: any) {
    switch (buttonAction) {
      case 'localImport':
        this.localFileSelector.selectedFileName = '';
        this.displayDialog = true;
        break;
      case 'remoteImport':
        this.getDocument(parameter);
        break;
      case 'loadMessage':
        if (parameter != '') {
          this.injector.get(Art57Section).showTooltipMessage({ severity: 'success', detail: 'Importing evprm message', life: environment.successElapsedTime });
          this.injector.get(WebtraderService).loading.next(true);
          this.localFileSelector.initComponent();
          this.displayDialog = false;
          setTimeout(() => this.buttonAction.emit({ action: buttonAction, param: parameter }), 100);
        } else {
          this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'XML file not selected or is empty', life: environment.warningElapsedTime });
        }
        break;
      case 'reloadImport':
        setTimeout(() => {
          this.doReloadImport(parameter);
        }, 0);

        break;
      case 'validate':
        let importedMessage: any = null;

        if (parameter instanceof TreeNodeXEVPRMImportedMessage) {
          importedMessage = parameter;
        } else {
          importedMessage = Art57NodeUtils.findFirstParentNodeOfType(parameter, TreeNodeXEVPRMImportedMessage);
        }
        const dataToSend = { action: buttonAction, param: importedMessage };
        this.buttonAction.emit(dataToSend);
        break;
      case 'selectAll':
        this.manageItemChecked(parameter, true);
        break
      case 'deselectAll':
        this.manageItemChecked(parameter, false);
        break
      case 'sortField':
        this.sortField(parameter);
        break;
      default:
        const data = { action: buttonAction, param: parameter };
        this.buttonAction.emit(data);
        break;
    }
  };

  isListViewNode() {
    return this.selectedNode instanceof Art57NodeList;
  }

  isTreeNodeImportedMessagesList() {
    return this.selectedNode instanceof TreeNodeImportedMessagesList;
  }

  isTreeNodeBulkUpdate() {
    return this.selectedNode instanceof BulkUpdateList;
  }

  isLocalImportNode() {
    return this.selectedNode instanceof TreeNodeImportedMessagesList;
  }

  isRemoteImportNode() {
    return ((this.selectedNode instanceof QueryResultNode || this.selectedNode instanceof QueryNode) && (!(this.selectedNode instanceof QueryConditionsNode)) || this.isRemoteImportBulkUpdate());
  }

  isRemoteImportBulkUpdate() {
    return this.selectedNode instanceof BulkUpdateList && this.selectedNode.data.model.some((item: { fileName: string; }) => item.fileName.toLowerCase().endsWith('.xml'));
  }

  isEnabledSelectAll(selectedNode: any) {
    let atLeastOneItemUnChecked = (this.selectedNode as Art57Node).children?.some(child => !child.checked);
    if (this.isResultNode() || this.isRefreshAllowed()) {
      atLeastOneItemUnChecked = this.getStatusAllQueryResultNode(selectedNode, false);
    } else if (this.isTreeNodeBulkUpdate()) {
      const arrayModel: [] = Object.assign(selectedNode.data.model);
      atLeastOneItemUnChecked = arrayModel.some((item: any) => { return (!(item.fileName === 'back_arrow')) && (!item.checked) });
    }
    return atLeastOneItemUnChecked;
  }

  isEnabledDeselectAll(selectedNode: any) {
    let atLeastOneItemChecked = (this.selectedNode as Art57Node).children?.some(child => child.checked);
    if (this.isResultNode() || this.isRefreshAllowed()) {
      atLeastOneItemChecked = this.getStatusAllQueryResultNode(selectedNode, true);
    } else if (this.isConditionsNode()) {
      atLeastOneItemChecked = selectedNode.data.model &&
        Object.keys(selectedNode.data.model).some(key => selectedNode.data.model[key] !== undefined && selectedNode.data.model[key] !== null && selectedNode.data.model[key] !== '');
    } else if (this.isTreeNodeBulkUpdate()) {
      const arrayModel: [] = Object.assign(selectedNode.data.model);
      atLeastOneItemChecked = arrayModel.some((item: any) => { return (!(item.fileName === 'back_arrow')) && (item.checked) });
    }
    return atLeastOneItemChecked;
  }

  isRemoveAllowed() {
    return this.selectedNode instanceof TreeNodeImportedMessagesList ||
      this.selectedNode instanceof TreeNodeXEVPRMImportedMessage ||
      this.selectedNode instanceof QueryResultNode;
  }

  isTreeNodeXEVPRMImportedMessage() {
    return this.selectedNode instanceof TreeNodeXEVPRMImportedMessage && this.injector.get(SectionService).isAllowedProductReports();
  }

  isQueryNode() {
    return (this.selectedNode instanceof QueryNode);
  }

  isConditionsNode() {
    return this.selectedNode instanceof QueryConditionsNode;
  }

  isRefreshAllowed() {
    return this.selectedNode instanceof QueryNodeInBox ||
      this.selectedNode instanceof QueryNodeOutBox ||
      this.selectedNode instanceof QueryNodeToEudravigilance ||
      this.selectedNode instanceof QueryNodeFromEudravigilance ||
      this.isTreeNodeBulkUpdate();
  }

  isResultNode() {
    return this.selectedNode instanceof QueryResultNode;
  }

  isResultList() {
    return this.selectedNode instanceof ResultList;
  }

  isPaginationAllowed() {
    return this.isResultNode()
      || this.selectedNode instanceof QueryNodeMessageBox;
  }

  async getDocument(node: any) {
    const checkedItem = node.data.model.filter((i: any) => i.checked === true);
    if (checkedItem == undefined || checkedItem.length === 0) {
      this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'No files selected', life: environment.warningElapsedTime });
      return;
    } else if (checkedItem.length > 1) {
      this.injector.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: 'Please select only one file', life: environment.warningElapsedTime });
      return;
    } else {
      this.getXML(checkedItem[0]).then(data => {
        this.createFile(data);

        let type: IMPORT_TYPE = IMPORT_TYPE.EVPRM;
        if (node instanceof QueryNodeInBox
          || node.parent?.parent instanceof QueryNodeInBox
          || node instanceof QueryNodeFromEudravigilance
          || node.parent?.parent instanceof QueryNodeFromEudravigilance
        ) {
          type = IMPORT_TYPE.ACKEVPRM;
        }

        this.injector.get(WebtraderService).import(this.selectedFile!, type).subscribe((message) => {
          if (type == IMPORT_TYPE.EVPRM) {
            this.onButtonAction("loadMessage", JSON.stringify(message));
          } else {
            this.onButtonAction("loadAck", JSON.stringify(message));
          }
        });

      });
    }




  }

  createFile(data: string) {
    const blob = new Blob([data], { type: 'application/xml' });
    this.selectedFile = new File([blob], 'file.xml', { type: 'application/xml' });
  }

  getXML(model: any): Promise<string> {
    return new Promise((resolve, reject) => {
      let lookupName: string = '';
      if (this.selectedNode instanceof QueryNodeInBox ||
        this.selectedNode.parent instanceof ResultListNodeInbox ||
        this.selectedNode instanceof QueryNodeToEudravigilance ||
        this.selectedNode.parent instanceof ResultListNodeToEudravigilance) {
        lookupName = 'inboundmessage';
      }
      else if (this.selectedNode instanceof QueryNodeOutBox ||
        this.selectedNode instanceof QueryNodeFromEudravigilance ||
        this.selectedNode.parent instanceof ResultListNodeOutbox ||
        this.selectedNode.parent instanceof ResultListNodeFromEudravigilance) {
        lookupName = 'outboundmessage';
      } else {
        lookupName = 'bulkUpdate';
      }
      if ((lookupName === 'inboundmessage') || (lookupName === 'outboundmessage')) {
        this.injector.get(LookupGetService).get(lookupName, model.id).subscribe({
          next: data => {
            resolve(data.name);
          },
          error: () => {
            reject('');
          }
        });
      } else if (lookupName === 'bulkUpdate') {

        this.injector.get(WebtraderService).getBulkUpdateContent(model.path).subscribe({
          next: (data) => {
            resolve(data.content);
          },
          error: () => {
            reject('');
          }

        });

      }

    })

  }


  isImportMessageWithErrors(selectedNode: any) {
    let importedMessage: any = null;

    if (selectedNode instanceof TreeNodeXEVPRMImportedMessage) {
      importedMessage = selectedNode;
    } else {
      importedMessage = Art57NodeUtils.findFirstParentNodeOfType(selectedNode, TreeNodeXEVPRMImportedMessage);
    }

    return (importedMessage != null) && (importedMessage instanceof TreeNodeXEVPRMImportedMessage);
  }

  showSelectAll() {
    return  this.isTreeNodeImportedMessagesList();
  }

  showDeselectAll() {
    return (this.isListViewNode() && this.isTreeNodeImportedMessagesList()) 
      || this.selectedNode instanceof QueryNodeInBox 
      || this.selectedNode instanceof QueryNodeOutBox 
      || this.selectedNode instanceof QueryNodeToEudravigilance
      || this.selectedNode instanceof QueryNodeFromEudravigilance
      || this.isResultNode() 
      || this.isConditionsNode() 
      || (this.isTreeNodeBulkUpdate() && this.selectedNode.path && Array.from(this.selectedNode.path).filter(c => c === '#').length === 2);
  }

  manageItemChecked(node: BaseNode, checkedStatus: boolean) {
    if (this.isResultNode() || this.isRefreshAllowed()) {
      this.manageResultNodeItemChecked(node, checkedStatus);
    } else if (this.isListViewNode() && this.isTreeNodeImportedMessagesList()) {
      this.manageTreeNodeImportMessagesList(node, checkedStatus);
    } else if (node instanceof QueryConditionsNode) {
      this.uncheckConditionsNode(node);
    } else if (this.isTreeNodeBulkUpdate()) {
      this.manageBulkUpdateNodeItemChecked(node, checkedStatus);
    }
  }

  manageResultNodeItemChecked(node: BaseNode, checkedStatus: boolean) {
    const arrayModel = Object.assign(node.data.model);
    arrayModel.forEach((item: any) => item.checked = checkedStatus);
  }

  manageBulkUpdateNodeItemChecked(node: BaseNode, checkedStatus: boolean) {
    const arrayModel = Object.assign(node.data.model);
    arrayModel.forEach((item: any) => { if (!(item.fileName === 'back_arrow')) { item.checked = checkedStatus } });
  }

  manageTreeNodeImportMessagesList(node: BaseNode, checkedStatus: boolean) {
    this.injector.get(Art57Section).changeSelectAll(node, checkedStatus);
  }

  getStatusAllQueryResultNode(selectedNode: BaseNode, checkvalue: boolean): boolean {
    let result = false;
    if (selectedNode.data.model) {
      const arrayModel = Object.values(selectedNode.data.model);
      result = arrayModel.some((item: any) => item.checked == checkvalue);
    }
    return result;
  }

  uncheckConditionsNode(node: BaseNode) {
    let keys = Object.keys(node.data.model);
    keys.forEach(key => { node.data.model[key] = "" });
    node.data.fields = [...node.data.fields];
  }

  showSortButton() {
    return this.isConditionsNode();
  }

  sortField(selectedNode: BaseNode) {
    selectedNode.data.fields.sort((a: any, b: any) => {
      let labelA = a.props["label"] || '';
      let labelB = b.props["label"] || '';

      return this.sortOrder ? labelA.localeCompare(labelB) : labelB.localeCompare(labelA);
    });

    this.sortOrder = !this.sortOrder;
    selectedNode.data.fields = [...selectedNode.data.fields];
  }

  showRemoveItemsWebtraderNodeButton() {
    let result = false;
    let children = this.selectedNode.children
    if (children && children.length > 0) {
      result = (this.isListViewNode() && this.isRemoveAllowed()) || this.isResultList();
    }
    return result;
  }
  
  onDialogClose() {
    this.fileContent = '';
  }

}
